<template>
    <v-container fluid>
        <ConfigurationForm
            :configuration="configuration"
            @saved="saved"
            v-if="configuration"
        />

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import ConfigurationModel from '@/models/commission/Configuration'
import ConfigurationForm from './Form'

export default {
    props: {
        id: {
            required: true,
        },
    },

    data: () => {
        return {
            configuration: null,
        }
    },

    components: {
        ConfigurationForm,
    },

    methods: {
        async getConfiguration() {
            let configuration = await this.model.find(this.id)

            this.configuration = configuration
        },

        saved() {
            this.$router.push({
                name: this.$t('commissions.configurations.routes.index'),
            })
        },
    },

    computed: {
        model() {
            return new ConfigurationModel()
        },
    },

    created() {
        this.getConfiguration()
    },
}
</script>
